var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "95px",
    height: "95px",
    viewBox: "0 0 846.66 846.66",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .fil0 {fill:black;fill-rule:nonzero}  ")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M174.61 513.03l0 -481.99c0,-11.4 9.24,-20.64 20.64,-20.64l458.76 0c87.86,0 159.66,71.8 159.66,159.66l0 503.93c0,11.41 -9.24,20.65 -20.64,20.65l-436.81 0c-10.26,80.85 -79.33,141.62 -160.97,141.62 -89.61,0 -162.26,-72.65 -162.26,-162.27 0,-81.63 60.78,-150.7 141.62,-160.96zm-59.12 194.24c-19.2,-19.2 10,-48.39 29.2,-29.19l28.09 28.09 70.38 -108.12c14.72,-22.67 49.24,-0.25 34.52,22.42l-83.38 128.07c-6.51,12.05 -22.93,14.61 -32.76,4.78l-46.05 -46.05zm240.73 -53.92l416.16 0 0 -483.29c0,-65.06 -53.31,-118.37 -118.37,-118.37l-438.11 0 0 461.34c73.1,9.28 131.04,67.21 140.32,140.32zm-160.97 -100.33c-66.81,0 -120.97,54.16 -120.97,120.97 0,66.82 54.16,120.98 120.97,120.98 66.82,0 120.98,-54.16 120.98,-120.98 0,-66.81 -54.16,-120.97 -120.98,-120.97zm428.34 -254.17l92.1 0c11.4,0 20.64,9.25 20.64,20.65l0 217.21c0,11.4 -9.24,20.65 -20.64,20.65l-92.1 0c-11.4,0 -20.65,-9.25 -20.65,-20.65l0 -217.21c0,-11.4 9.25,-20.65 20.65,-20.65zm71.45 41.29l-50.81 0 0 175.92 50.81 0 0 -175.92zm-170.49 -163.34c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm0 69.51c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm-255.44 218.95c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.3 0,-41.3l205.04 0c27.16,0 27.16,41.3 0,41.3l-205.04 0zm4.34 -253.29l152.92 0c11.4,0 20.64,9.24 20.64,20.64l0 152.92c0,11.4 -9.24,20.65 -20.64,20.65l-152.92 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -152.92c0,-11.4 9.24,-20.64 20.64,-20.64zm132.27 41.29l-111.62 0 0 111.63 111.62 0 0 -111.63z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.2f11007acb70453c550d7462f82f25a9.svg";
export { ForwardRef as ReactComponent };